const FEEDBACK_SESSION_KEY = 'feedback_session_id';

const createSessionId = () => {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return `feedback-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

export const getFeedbackSessionId = () => {
  let sessionId = localStorage.getItem(FEEDBACK_SESSION_KEY);
  if (!sessionId) {
    sessionId = createSessionId();
    localStorage.setItem(FEEDBACK_SESSION_KEY, sessionId);
  }
  return sessionId;
};

export const ONBOARDING_EXIT_STEP_KEY = 'onboarding_exit_step';
export const ONBOARDING_EXIT_AT_KEY = 'onboarding_exit_at';
